import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import PaymentMethodTableFilter from "../Filters/PaymentMethodTableFilter";
import PaymentMethodAddForm from "../Forms/PaymentMethodAddForm";
import PaymentMethodUpdateForm from "../Forms/PaymentMethodUpdateForm";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
  notification,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const PaymentMethod = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [nameKey, setNameKey] = useState(
    props?.nameKey || "Ödeme Şekli Tanımları"
  );
  const [useComponentForPolicy, setUseComponentForPolicy] = useState(
    props?.useComponentForPolicy || false
  );

  useEffect(() => {
    if (props) {
      setNameKey(props?.nameKey);
      setUseComponentForPolicy(props?.useComponentForPolicy);
    }
  }, []);
  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(
      `/PaymentMethod?$count=true${filter}&$skip=${skip}&$top=${take}&$orderby=addDate desc`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/PaymentMethod/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/PaymentMethod/${id}`).then((response) => {
      if (response?.success) {
        getTableData();
      }
    });
  };

  const onClickChangeStatus = (id) => {
    RequestHandler.post(`/PaymentMethod/ChangeStatus/${id}`).then(
      (response) => {
        if (response?.success) {
          getTableData();
        }
      }
    );
  };

  const onAddSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const columns = [
    {
      title: `${nameKey} Adı`,
      dataIndex: "name",
    },

    !useComponentForPolicy
      ? {
          title: "Ödeme Seti",
          render: (row) => row.paymentSetName ?? "Varsayılan",
        }
      : {},
    {
      title: "Düzenle",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : (
          <a
            onClick={() => {
              openNotificationWithIcon("warning");
            }}
            style={{
              color: "orange",
              fontSize: "130%",
              paddingBottom: "20px",
            }}
          >
            <EditOutlined />
          </a>
        ),

      // render: (row) => (
      //   <a onClick={() => handleOnClickUpdate(row)}>
      //     <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
      //   </a>
      // ),
    },
    {
      title: "Durum",
      dataIndex: "isActive",
      align: "center",
      render: (text, row) => {
        const { title, icon } = row.isActive
          ? {
              title: `${nameKey}'ni pasif etmek istiyor musunuz?`,
              icon: (
                <Tooltip title="Pasif et">
                  <CheckCircleOutlined
                    style={{ color: "green", fontSize: "130%" }}
                  />
                </Tooltip>
              ),
            }
          : {
              title: `${nameKey}'ni aktif etmek istiyor musunuz?`,
              icon: (
                <Tooltip title="Aktif Et">
                  <CloseCircleOutlined
                    style={{ color: "red", fontSize: "130%" }}
                  />
                </Tooltip>
              ),
            };
        return (
          <Popconfirm
            title={title}
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => onClickChangeStatus(row.id)}
          >
            <a>{icon}</a>
          </Popconfirm>
        );
      },
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: `Pasif olan ${nameKey} tanımları güncellenemez.`,
    });
  };

  return (
    <>
      <Row align="middle">
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginBottom: 0 }}>
            <BarsOutlined /> {props?.title}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> {nameKey} Ekle
          </Button>
        </Col>
      </Row>

      <PaymentMethodTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        nameKey={nameKey}
        useComponentForPolicy={useComponentForPolicy}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addPaymentMethodDrawer"
        title={nameKey + " Ekle"}
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <PaymentMethodAddForm
          onSuccess={onAddSuccess}
          nameKey={nameKey}
          useComponentForPolicy={useComponentForPolicy}
        />
      </Drawer>

      <Drawer
        id="updatePaymentMethodDrawer"
        title={nameKey + " Güncelle"}
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <PaymentMethodUpdateForm
          data={updateFormData}
          onSuccess={onUpdateSuccess}
          nameKey={nameKey}
          useComponentForPolicy={useComponentForPolicy}
        />
      </Drawer>
    </>
  );
};

export default PaymentMethod;
